import type { ProjectResource } from "@octopusdeploy/octopus-server-client";
import React from "react";
import { EditDeploymentFreeze } from "~/components/DeploymentFreezes/EditDeploymentFreeze";
interface CreateProjectDeploymentFreezePageProps {
    project: ProjectResource;
    spaceId: string;
}
export function CreateProjectDeploymentFreezePage({ project }: CreateProjectDeploymentFreezePageProps) {
    return <EditDeploymentFreeze create={true} project={project}/>;
}
